module.exports = __webpack_public_path__ + "static/img/ITSS31.d36d158.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ITSS31.png
// module id = p3fC
// module chunks = 0